import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import YoutubeProfilesService from '@/services/YoutubeProfilesService';

export async function fetchProfiles({ commit, state }, { page, size, search } = {}) {
  const currentPage = page !== undefined ? page : state.currentPage;
  const currentSize = size !== undefined ? size : state.pageSize;
  const currentSearch = search !== undefined ? search : state.search;

  commit(MUTATE_MULTIPLE, [
    { property: 'loading', with: true },
    { property: 'error', with: null },
  ]);

  try {
    const data = await YoutubeProfilesService.getProfiles({ page: currentPage, size: currentSize, search: currentSearch });
    commit(MUTATE_MULTIPLE, [
      { property: 'profiles', with: data.content },
      { property: 'totalElements', with: data.total_elements },
      { property: 'totalPages', with: data.total_pages },
      { property: 'currentPage', with: data.page },
      { property: 'pageSize', with: data.size },
      { property: 'search', with: currentSearch },
    ]);
  } catch (err) {
    commit(MUTATE, { property: 'error', with: err });
  } finally {
    commit(MUTATE, { property: 'loading', with: false });
  }
}

export async function deleteProfiles({ commit, dispatch, state }, ids = []) {
  commit(MUTATE_MULTIPLE, [
    { property: 'loading', with: true },
    { property: 'error', with: null },
  ]);

  try {
    await YoutubeProfilesService.deleteProfiles(ids);
    commit(MUTATE, { property: 'selectedIds', with: [] });
    await dispatch('fetchProfiles', { page: state.currentPage, size: state.pageSize });
  } catch (err) {
    commit(MUTATE, { property: 'error', with: err });
    commit(MUTATE, { property: 'loading', with: false });
    throw err;
  }
}

export async function createProfile({ dispatch, state }, profileData) {
  try {
    await YoutubeProfilesService.createProfile(profileData);
    await dispatch('fetchProfiles', { page: state.currentPage, size: state.pageSize });
  } catch (err) {
    throw err;
  }
}

export async function createBatch(_context, entries = []) {
  return YoutubeProfilesService.createBatch(entries);
}
